// v-reveal — az elem beúszik, amikor a görgetéssel láthatóvá válik.
//
//   class="reveal"              alulról úszik fel
//   class="reveal reveal-left"  balról (reveal-right / reveal-zoom is van)
//   v-reveal                    figyeli az elemet, és láthatóvá teszi
//   v-reveal="2"                a rácsban a 3. elem -> lépcsőzetes késleltetés
//
// A rejtő osztály szándékosan a template-ben áll, nem a direktíva teszi fel:
// így az SSR és a kliens ugyanazt a class-listát látja (nincs hydration
// mismatch), és nincs villanás sem. A .reveal / .reveal-in stílusok az
// assets/main.css-ben vannak, mert sok komponens elemeire kerülnek.

export default defineNuxtPlugin((nuxtApp) => {
  // JS nélküli böngészőben a rejtő osztály miatt üres lenne az oldal.
  useHead({
    noscript: [{
      children: '<style>.reveal{opacity:1!important;transform:none!important}.title-rule{transform:none!important}</style>',
      tagPosition: 'head',
    }],
  })

  let observer = null

  function getObserver() {
    if (observer) return observer
    observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue
        entry.target.classList.add('reveal-in')
        observer.unobserve(entry.target)
      }
    }, {
      // Nem a window görget, hanem a layout .main div-je (layouts/default.vue).
      root: document.querySelector('.main'),
      rootMargin: '0px 0px -6% 0px',
      threshold: 0.05,
    })
    return observer
  }

  nuxtApp.vueApp.directive('reveal', {
    mounted(el, binding) {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      if (reducedMotion || typeof IntersectionObserver === 'undefined') {
        el.classList.add('reveal-in')
        return
      }

      const step = Number(binding.value)
      if (step > 0) el.style.transitionDelay = `${Math.min(step, 6) * 90}ms`

      getObserver().observe(el)
    },
    unmounted(el) {
      if (observer) observer.unobserve(el)
    },
  })
})
